var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", {}, [
      _c(
        "div",
        {
          class: { "table-responsive": true, "text-nowrap": !_vm.fitCellSizes },
        },
        [
          _c(
            "table",
            {
              staticClass:
                "table table-sm table-condensed table-hover table-bordered small m-0",
            },
            [
              _c("thead", [
                _c(
                  "tr",
                  [
                    _vm.showTotals
                      ? _c("th", { staticClass: "border-0" })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.multiselect && _vm.showMultiColumn
                      ? _c(
                          "th",
                          { staticClass: "text-center subtable-header-style" },
                          [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.lstOfDatRows &&
                                      _vm.lstOfDatRows.length > 0,
                                    expression:
                                      "lstOfDatRows && lstOfDatRows.length > 0",
                                  },
                                ],
                                staticClass: "wPointer",
                              },
                              [
                                !_vm.isAllRowSelected
                                  ? _c("span", {
                                      staticClass:
                                        "mdi mdi-checkbox-blank-outline",
                                      on: {
                                        click: function ($event) {
                                          return _vm.fnToggleAllSel()
                                        },
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.isAllRowSelected
                                  ? _c("span", {
                                      staticClass:
                                        "mdi mdi-checkbox-marked-outline",
                                      on: {
                                        click: function ($event) {
                                          return _vm.fnToggleAllSel()
                                        },
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("sup", {}, [
                                  _vm._v(
                                    _vm._s(_vm.$n(_vm.selectedRows.length))
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasSubtable
                      ? _c("th", {
                          staticClass: "text-center subtable-header-style",
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.lstColumns, function (column) {
                      return _vm.fnEvalCondition(column.Conditions) &&
                        _vm.fnIsVisible(column) &&
                        column.gtShown
                        ? _c(
                            "th",
                            {
                              class: {
                                sorted: column.sort != "NOS",
                                "subtable-header-style": column.sort == "NOS",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  class: { wPointer: column.CanSort == true },
                                  on: {
                                    click: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "left",
                                          37,
                                          $event.key,
                                          ["Left", "ArrowLeft"]
                                        )
                                      )
                                        return null
                                      if (
                                        "button" in $event &&
                                        $event.button !== 0
                                      )
                                        return null
                                      $event.preventDefault()
                                      return _vm.fnSortBy(column)
                                    },
                                    contextmenu: function ($event) {
                                      $event.preventDefault()
                                      return _vm.fnShowColModal(column)
                                    },
                                  },
                                },
                                [
                                  _c("div", {}, [
                                    column.sort == "NOS" &&
                                    column.CanSort == true
                                      ? _c("span", {
                                          staticClass: "mdi mdi-record",
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    column.sort == "DESC" &&
                                    column.CanSort == true
                                      ? _c("span", {
                                          staticClass:
                                            "mdi mdi-play mdi-rotate-90",
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    column.sort == "ASC" &&
                                    column.CanSort == true
                                      ? _c("span", {
                                          staticClass:
                                            "mdi mdi-play mdi-rotate-270",
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !column.IconHeader
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("capitalize")(column.Label)
                                            )
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    column.IconHeader
                                      ? _c("span", { class: column.IconHeader })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.badgeColSortOrder(column) != -1
                                      ? _c("sup", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.badgeColSortOrder(column)
                                            )
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]),
                                ]
                              ),
                            ]
                          )
                        : _vm._e()
                    }),
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _vm._l(_vm.lstOfDatRows, function (entry, index) {
                return _c("tbody", [
                  _c(
                    "tr",
                    {
                      class: {
                        "table-secondary": _vm.isRowSelected(entry),
                        "bg-info-row": _vm.applyInfoBackground,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.fnRowClick(entry, index)
                        },
                        dblclick: function ($event) {
                          return _vm.fnDoubleRowClick(entry, index)
                        },
                        mouseover: function ($event) {
                          return _vm.fnMouseOver(index)
                        },
                        mouseleave: function ($event) {
                          return _vm.fnMouseLeave(index)
                        },
                      },
                    },
                    [
                      _vm.showTotals
                        ? _c("td", { staticClass: "border-0" })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.multiselect && _vm.showMultiColumn
                        ? _c(
                            "td",
                            { staticClass: "text-center align-middle" },
                            [
                              _c("div", { staticClass: "wPointer" }, [
                                _c("span", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.isRowSelected(entry),
                                      expression: "!isRowSelected(entry)",
                                    },
                                  ],
                                  staticClass: "mdi mdi-checkbox-blank-outline",
                                }),
                                _vm._v(" "),
                                _c("span", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.isRowSelected(entry),
                                      expression: "isRowSelected(entry)",
                                    },
                                  ],
                                  staticClass:
                                    "mdi mdi-checkbox-marked-outline",
                                }),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasSubtable
                        ? _c(
                            "td",
                            {
                              staticClass: "text-center align-middle",
                              on: {
                                click: function ($event) {
                                  entry.collapsed = !entry.collapsed
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "wPointer" }, [
                                _c("span", {
                                  class: `mdi mdi-chevron-${
                                    entry.collapsed ? "right" : "down"
                                  }`,
                                }),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.lstColumns, function (col) {
                        return _vm.fnEvalCondition(col.Conditions) &&
                          _vm.fnIsVisible(col) &&
                          col.gtShown
                          ? _c(
                              "td",
                              {
                                staticClass: "align-middle",
                                style: _vm.fnCssCellStyle(entry, col, index),
                                attrs: { title: _vm.$t(col.Tooltip) },
                              },
                              [
                                col.ParamId == null && col.CellType == null
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "ellipsis-line-clamp-4",
                                        attrs: {
                                          title: _vm.fnGetDataValue(entry, col),
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm.fnGetDataValue(entry, col)
                                            ) +
                                            "\n                            "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                col.ParamId != null &&
                                (!col.conditionalValues ||
                                  col.conditionalValues.filter(
                                    (x) => x.Value != ""
                                  ).length == 0)
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "ellipsis-line-clamp-4",
                                        attrs: {
                                          title: _vm.formatValueCodParam(
                                            _vm.fnGetDataValue(entry, col),
                                            col.ParamId
                                          ),
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatValueCodParam(
                                              _vm.fnGetDataValue(entry, col),
                                              col.ParamId
                                            )
                                          )
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                col.CellType == "FlagType"
                                  ? _c("country-flag", {
                                      attrs: {
                                        country: _vm.fnGetDataValue(entry, col),
                                        size: "normal",
                                        rounded: "",
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                col.CellType == "StringType"
                                  ? _c("cell-dt-string-type-component", {
                                      attrs: {
                                        value: _vm.fnGetDataValue(entry, col),
                                        index: index,
                                        readTransform: col.ReadTransform,
                                        conditionsDict: col.conditionalValues,
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                col.CellType == "DateType"
                                  ? _c("cell-dt-date-type-component", {
                                      attrs: {
                                        value: _vm.fnGetDataValue(entry, col),
                                        format: col.Format,
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                col.CellType == "NumberType"
                                  ? _c("cell-dt-number-type-component", {
                                      attrs: {
                                        value: _vm.fnGetDataValue(entry, col),
                                        outcomes: col.Values,
                                        format: col.Format,
                                        readTransform: col.ReadTransform,
                                        conditionsDict: col.conditionalValues,
                                        index: index,
                                        currency: _vm.getCurrencyParam(index),
                                        area: _vm.getAreaParam(index),
                                        frequency: _vm.getFreqParam(index),
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                col.CellType == "BooleanType"
                                  ? _c("cell-dt-boolean-type-component", {
                                      attrs: {
                                        value: _vm.fnGetDataValue(entry, col),
                                        outcomes: col.Values,
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                col.CellType == "LinkType"
                                  ? _c("cell-dt-link-type-component", {
                                      attrs: {
                                        value: _vm.fnGetDataValue(entry, col),
                                        paramValue:
                                          col.ParamId != null
                                            ? _vm.formatValueCodParam(
                                                _vm.fnGetDataValue(entry, col),
                                                col.ParamId
                                              )
                                            : null,
                                        index: index,
                                        conditionsDict: col.conditionalValues,
                                        readTransform: col.ReadTransform,
                                        format: col.Format,
                                        currency: _vm.getCurrencyParam(index),
                                        area: _vm.getAreaParam(index),
                                        frequency: _vm.getFreqParam(index),
                                        precedent: _vm.getPrecedentNum(index),
                                      },
                                      on: {
                                        "btn-click": function ($event) {
                                          return _vm.fnCallBack(
                                            $event,
                                            col,
                                            entry
                                          )
                                        },
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                col.CellType == "ToggleType"
                                  ? _c("cell-dt-toggle-type-component", {
                                      attrs: {
                                        value: _vm.fnGetDataValue(entry, col),
                                        index: index,
                                        toggleKey: _vm.keyDate,
                                        color: "var(--jll-red)",
                                        readTransform: col.ReadTransform,
                                      },
                                      on: {
                                        "btn-click": function ($event) {
                                          return _vm.fnCallBack(
                                            $event,
                                            col,
                                            entry
                                          )
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _vm._e()
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.hasSubtable && !entry.collapsed
                    ? _c("tr", [
                        _c(
                          "td",
                          {
                            staticClass: "subtableFontSize subtableBackground",
                            attrs: { colspan: 2 * _vm.lstColumns.length },
                          },
                          [
                            _c(
                              "keep-alive",
                              [
                                _c(_vm.subtableComponent.component, {
                                  tag: "component",
                                  attrs: { id: entry[_vm.keyField] },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                ])
              }),
            ],
            2
          ),
        ]
      ),
      _vm._v(" "),
      _vm.loading
        ? _c(
            "div",
            [
              _c("v-progress-linear", {
                attrs: { indeterminate: "", color: "rgb(100, 100, 100)" },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.lstOfDatRows || _vm.lstOfDatRows.length == 0
        ? _c("div", [
            !_vm.loading
              ? _c(
                  "div",
                  {
                    staticClass: "alert alert-warning text-center",
                    attrs: { role: "alert" },
                  },
                  [_vm._v("\n                No Data\n            ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.loading
              ? _c(
                  "div",
                  { staticClass: "alert alert-secondary text-center" },
                  [_vm._v("\n                Loading\n            ")]
                )
              : _vm._e(),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", [
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: _vm.idcolumnListModal,
            "data-backdrop": "static",
            tabindex: "-1",
            role: "dialog",
            "aria-hidden": "true",
          },
        },
        [
          _c(
            "div",
            { staticClass: "modal-dialog", attrs: { role: "document" } },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("h5", { staticClass: "modal-title" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("components.genericTable.columnList.modalTitle")
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._m(0),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body p-0" }, [
                  _c("div", { staticClass: "table-responsive text-nowrap" }, [
                    _c(
                      "table",
                      {
                        staticClass:
                          "table table-sm table-condensed table-hover table-bordered small m-0",
                      },
                      [
                        _c("thead", [
                          _c("tr", [
                            _c("th", [
                              _vm._v(
                                "\n                                            " +
                                  _vm._s(
                                    _vm.$t(
                                      "components.genericTable.columnList.index"
                                    )
                                  ) +
                                  "\n                                        "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("th", { attrs: { width: "100%" } }, [
                              _vm._v(
                                "\n                                            " +
                                  _vm._s(
                                    _vm.$t(
                                      "components.genericTable.columnList.column"
                                    )
                                  ) +
                                  "\n                                        "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("th", { staticClass: "text-center" }, [
                              _vm._v(
                                "\n                                            " +
                                  _vm._s(
                                    _vm.$t(
                                      "components.genericTable.columnList.isVisible"
                                    )
                                  ) +
                                  "\n                                        "
                              ),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "draggable",
                          {
                            attrs: { tag: "tbody", handle: ".handle" },
                            model: {
                              value: _vm.lstColumns,
                              callback: function ($$v) {
                                _vm.lstColumns = $$v
                              },
                              expression: "lstColumns",
                            },
                          },
                          _vm._l(_vm.lstColumns, function (column, index) {
                            return _vm.fnEvalCondition(column.Conditions) &&
                              _vm.fnIsVisible(column)
                              ? _c("tr", { key: column.gtOrder }, [
                                  _c(
                                    "td",
                                    {
                                      class: {
                                        "text-muted": column.gtShown == false,
                                      },
                                    },
                                    [
                                      _c("div", {}, [
                                        _c("span", {
                                          staticClass:
                                            "mdi mdi-menu grabbable handle",
                                        }),
                                        _vm._v(
                                          "\n                                                " +
                                            _vm._s(index) +
                                            "\n                                            "
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      class: {
                                        "text-muted": column.gtShown == false,
                                      },
                                      attrs: { width: "100%" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                            " +
                                          _vm._s(
                                            _vm._f("capitalize")(
                                              _vm.$t(column.Label)
                                            )
                                          ) +
                                          "\n                                        "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      class: {
                                        "text-center wPointer":
                                          column.gtShown == true,
                                        "text-center table-secondary wPointer":
                                          column.gtShown == false,
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          on: {
                                            click: function ($event) {
                                              column.gtShown = !column.gtShown
                                            },
                                          },
                                        },
                                        [
                                          !column.gtShown
                                            ? _c("span", {
                                                staticClass:
                                                  "mdi mdi-checkbox-blank-outline",
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          column.gtShown
                                            ? _c("span", {
                                                staticClass:
                                                  "mdi mdi-checkbox-marked-outline",
                                              })
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e()
                          }),
                          0
                        ),
                      ],
                      1
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-warning",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.fnResetTableConf()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.lblReset")))]
                  ),
                  _vm._v(" "),
                  _vm.uniqueTableName
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-outline-primary",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.fnSaveTableConf()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.lblSave")))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "button", "data-dismiss": "modal" },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.lblClose")))]
                  ),
                ]),
              ]),
            ]
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close",
        },
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }